import { render, staticRenderFns } from "./PdfView.vue?vue&type=template&id=d8227a7a&scoped=true&"
import script from "./PdfView.vue?vue&type=script&lang=js&"
export * from "./PdfView.vue?vue&type=script&lang=js&"
import style0 from "./PdfView.vue?vue&type=style&index=0&id=d8227a7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8227a7a",
  null
  
)

export default component.exports